module.exports = __webpack_public_path__ + "static/mainsliderimage1.de5b86c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mb/home/mainsliderimage1.jpg
// module id = 545
// module chunks = 35783957827783